import React from 'react';

export default function LotNotes({ lot }) {
  if (!lot.notes) return null;
  
  return (
    <div className="bg-white rounded-lg shadow px-4 py-5">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Notes</h3>
      <div className="text-sm text-gray-900 whitespace-pre-wrap bg-gray-50 p-4 rounded">
        {lot.notes}
      </div>
    </div>
  );
}
